import { put, select } from 'redux-saga/effects';
import { selectNotificationsQueue } from 'modules/Notifications/redux/selectors';
import { clearToastsQueue, showToast } from '../redux/actions';
import toastService from 'modules/Toasts/services/ToastService';

export function* showModalSaga() {
  yield toastService.dismiss();
  yield toastService.clearWaitingQueue();
}

export function* closeModalSaga() {
  const queue = yield select(selectNotificationsQueue);

  if (!queue.size) {
    return;
  }

  for (let notification of queue) {
    yield put(showToast(notification));
  }

  yield put(clearToastsQueue());
}
